import { useMutation } from "react-query";
import { axiosInstance } from "../../../../utils/axiosInstance";
import { message } from "antd";
import { queryClient } from "../../../../services/queryClient";

export const useDeleteSubjectMutation = () => {
  const token = localStorage.getItem("W2ST_ADMIN_TOKEN");

  return useMutation(
    ({ id }: { id: string }) =>
      axiosInstance
        .request({
          method: "DELETE",
          url: `admins/tutors/remove-tutor-subject/${id}`,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => res.data),
    {
      onSuccess: async () => {
        message.success("Subject deleted successfully");
        queryClient.invalidateQueries("useGetSubjectsQuery");
      },
      onError: (error: any) => {
        message.error(
          error?.response?.data?.message || "Failed... Please try again."
        );
      },
    }
  );
};
